module.exports = __webpack_public_path__ + "03a676620cab115b9fcc3dd9474b8e52.pdf";